var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "image-link"
  }, [_c('div', {
    staticClass: "image-link__bg",
    style: 'background-image:url(' + _vm.bg + ');'
  }), _c('div', {
    staticClass: "image-link__bg__on",
    style: 'background-image:url(' + _vm.bgOn + ');'
  }), _c('div', {
    staticClass: "image-link__content pa-20 pa-md-30 py-xl-34"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    class: 'image-link__tit ' + _vm.titWidth,
    attrs: {
      "cols": "auto"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")])]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "plus"
  }, [_c('span')])]), _c('v-col', {
    staticClass: "image-link__hidden",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mt-18 mt-xl-24 pt-18 pt-xl-30 border-top border-color-black"
  }, [_vm._t("default")], 2)])], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }